var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OceanFreightExpenseCard.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-494284cc\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OceanFreightExpenseCard.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/component/ulip/OceanFreightExpenseCard.vue
// module id = 2266
// module chunks = 0